<template>
  <transition name="cmp-slide">
    <div v-if="visivel" class="cmp-card">
      <p class="cmp-card-eyebrow">Passo 1 de {{ totalPassos }}</p>
      <h3 class="cmp-card-title">Como queres enviar?</h3>

      <div class="cmp-choice-group">
        <div class="cmp-choice" :class="{ 'is-selected': !isTeste }" @click="$emit('update:isTeste', false)">
          <div class="cmp-choice-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M4.5 16.5c-1.5 1.5-1.5 5.5 0 5.5s5-2 5-3.5L4.5 16.5z"/>
              <path d="M12 15l-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"/>
              <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0"/>
              <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"/>
            </svg>
          </div>
          <div>
            <div class="cmp-choice-name">Campanha real</div>
            <div class="cmp-choice-desc">Envia para os teus clientes</div>
          </div>
          <div class="cmp-choice-check"><i class="ni ni-check-bold"></i></div>
        </div>

        <div class="cmp-choice" :class="{ 'is-selected': isTeste }" @click="$emit('update:isTeste', true)">
          <div class="cmp-choice-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M14.5 2v11.5l4.5 7a1 1 0 0 1-.9 1.5H5.9A1 1 0 0 1 5 20.5l4.5-7V2"/>
              <path d="M8.5 2h7"/><path d="M8.5 13h7"/>
            </svg>
          </div>
          <div>
            <div class="cmp-choice-name">Modo teste</div>
            <div class="cmp-choice-desc">Só para destinatários de teste</div>
          </div>
          <div class="cmp-choice-check"><i class="ni ni-check-bold"></i></div>
        </div>
      </div>

      <div class="cmp-actions">
        <base-button type="primary" size="md" @click="$emit('avancar')">
          Continuar <i class="ni ni-bold-right ml-1"></i>
        </base-button>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "CampanhaPasso1",
  props: {
    visivel:    { type: Boolean, default: false },
    isTeste:    { type: Boolean, default: false },
    totalPassos:{ type: Number, default: 4 },
  },
};
</script>
